import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
import { PermitTypeFieldsFragmentFragmentDoc } from './DefaultPermitType.generated'
const defaultOptions = {}
export type IPermitTypeFragmentFragment = {
  id?: any | null
  orderIndex: number
  projectId: any
  name?: string | null
  basedOn?: any | null
  isEnabled: boolean
  categoryId?: any | null
  type: string
  shouldBlockOnNonWorkTimes?: boolean | null
  isAutoActivationEnabled?: boolean | null
  autoEndStepIds?: Array<any | null> | null
  isWorkflowTitleMandatory?: boolean | null
  isDeleted?: boolean | null
  iconName?: string | null
  createdAt?: any | null
  updatedAt?: any | null
  inspectionOptions?: {
    deadlineTime?: any | null
    inspectionFrequency?: number | null
    inspectionFrequencyType?: Types.CalendricalType | null
    selectedDaysToRepeat?: Array<number | null> | null
  } | null
  bookingDeadlineOptions?: {
    deadlineInterval?: any | null
    blockType?: Types.BlockTypeEnum | null
  } | null
  workflowSteps?: Array<{
    id?: any | null
    type: Types.WorkflowStepType
    workflowRuleIds: Array<any | null>
    notificationFieldIds: Array<any | null>
    notificationUserIds?: Array<any | null> | null
    requireAllSubmissions?: boolean | null
    bicCompletionMode?: Types.BicCompletionMode | null
    fields: Array<{
      id?: any | null
      parentId?: any | null
      type?: Types.PermitFieldType | null
      caption: string
      isMandatory?: boolean | null
      isShown?: boolean | null
      isMultiple?: boolean | null
      canEditIsShown: boolean
      canEditIsMandatory: boolean
      allowPreciseLocation?: boolean | null
      isUserStampEnabled?: boolean | null
      isLBSLogicEnabled?: boolean | null
      allowSelectExisting?: boolean | null
      allowCreateNew?: boolean | null
      selectOptions?: Array<string | null> | null
      isUsedInMaterial?: boolean | null
      mediaView?: Types.MediaViewType | null
      filterOptions?: Array<{
        propertyPath?: string | null
        operator: Types.OperatorType
        values?: Array<string | null> | null
        fieldId?: string | null
        fieldValues?: Array<string | null> | null
      } | null> | null
      instructions?: {
        list?: Array<string | null> | null
        listType?: string | null
      } | null
      checklist?: {
        listType?: string | null
        list?: Array<{
          id?: any | null
          text?: string | null
          questionnaireType?: string | null
        } | null> | null
      } | null
      inlineMediaItems?: Array<{
        fileName: string
        size: string
        url: string
      } | null> | null
      defaultOptions?: {
        sortOption?: string | null
        sortDirection?: Types.SortDirection | null
        groupOption?: string | null
        filterOptions?: Array<{
          type?: string | null
          values?: Array<string | null> | null
        } | null> | null
      } | null
    } | null>
    conditionalFields: Array<{
      fieldId: any
      key: string
      values: Array<{
        id?: any | null
        parentId?: any | null
        type?: Types.PermitFieldType | null
        caption: string
        isMandatory?: boolean | null
        isShown?: boolean | null
        isMultiple?: boolean | null
        canEditIsShown: boolean
        canEditIsMandatory: boolean
        allowPreciseLocation?: boolean | null
        isUserStampEnabled?: boolean | null
        isLBSLogicEnabled?: boolean | null
        allowSelectExisting?: boolean | null
        allowCreateNew?: boolean | null
        selectOptions?: Array<string | null> | null
        isUsedInMaterial?: boolean | null
        mediaView?: Types.MediaViewType | null
        filterOptions?: Array<{
          propertyPath?: string | null
          operator: Types.OperatorType
          values?: Array<string | null> | null
          fieldId?: string | null
          fieldValues?: Array<string | null> | null
        } | null> | null
        instructions?: {
          list?: Array<string | null> | null
          listType?: string | null
        } | null
        checklist?: {
          listType?: string | null
          list?: Array<{
            id?: any | null
            text?: string | null
            questionnaireType?: string | null
          } | null> | null
        } | null
        inlineMediaItems?: Array<{
          fileName: string
          size: string
          url: string
        } | null> | null
        defaultOptions?: {
          sortOption?: string | null
          sortDirection?: Types.SortDirection | null
          groupOption?: string | null
          filterOptions?: Array<{
            type?: string | null
            values?: Array<string | null> | null
          } | null> | null
        } | null
      } | null>
    } | null>
    actions?: Array<
      | {
          locationFieldIds?: Array<any | null> | null
          type?: Types.PermitActionType | null
        }
      | {
          type?: Types.PermitActionType | null
          locationFieldsMap?: Array<{
            fieldId: any
            specifiedPermitTypes?: Array<string | null> | null
            isDisabled?: boolean | null
          } | null> | null
        }
      | null
    > | null
  } | null> | null
  recurringOptions?: {
    isEnabled?: boolean | null
    maxDuration?: number | null
  } | null
  maxDurationOptions?: {
    isEnabled?: boolean | null
    durationType?: Types.WorkflowDurationType | null
    durationUnit?: Types.WorkflowDurationUnit | null
    duration?: number | null
  } | null
  defaultDurationOptions?: {
    isEnabled?: boolean | null
    durationType?: Types.WorkflowDurationType | null
    durationUnit?: Types.WorkflowDurationUnit | null
    duration?: number | null
  } | null
}

export type IPermitTypeListQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IPermitTypeListQuery = {
  permitTypes?: {
    data: Array<{
      id?: any | null
      orderIndex: number
      projectId: any
      name?: string | null
      basedOn?: any | null
      isEnabled: boolean
      categoryId?: any | null
      type: string
      shouldBlockOnNonWorkTimes?: boolean | null
      isAutoActivationEnabled?: boolean | null
      autoEndStepIds?: Array<any | null> | null
      isWorkflowTitleMandatory?: boolean | null
      isDeleted?: boolean | null
      iconName?: string | null
      createdAt?: any | null
      updatedAt?: any | null
      inspectionOptions?: {
        deadlineTime?: any | null
        inspectionFrequency?: number | null
        inspectionFrequencyType?: Types.CalendricalType | null
        selectedDaysToRepeat?: Array<number | null> | null
      } | null
      bookingDeadlineOptions?: {
        deadlineInterval?: any | null
        blockType?: Types.BlockTypeEnum | null
      } | null
      workflowSteps?: Array<{
        id?: any | null
        type: Types.WorkflowStepType
        workflowRuleIds: Array<any | null>
        notificationFieldIds: Array<any | null>
        notificationUserIds?: Array<any | null> | null
        requireAllSubmissions?: boolean | null
        bicCompletionMode?: Types.BicCompletionMode | null
        fields: Array<{
          id?: any | null
          parentId?: any | null
          type?: Types.PermitFieldType | null
          caption: string
          isMandatory?: boolean | null
          isShown?: boolean | null
          isMultiple?: boolean | null
          canEditIsShown: boolean
          canEditIsMandatory: boolean
          allowPreciseLocation?: boolean | null
          isUserStampEnabled?: boolean | null
          isLBSLogicEnabled?: boolean | null
          allowSelectExisting?: boolean | null
          allowCreateNew?: boolean | null
          selectOptions?: Array<string | null> | null
          isUsedInMaterial?: boolean | null
          mediaView?: Types.MediaViewType | null
          filterOptions?: Array<{
            propertyPath?: string | null
            operator: Types.OperatorType
            values?: Array<string | null> | null
            fieldId?: string | null
            fieldValues?: Array<string | null> | null
          } | null> | null
          instructions?: {
            list?: Array<string | null> | null
            listType?: string | null
          } | null
          checklist?: {
            listType?: string | null
            list?: Array<{
              id?: any | null
              text?: string | null
              questionnaireType?: string | null
            } | null> | null
          } | null
          inlineMediaItems?: Array<{
            fileName: string
            size: string
            url: string
          } | null> | null
          defaultOptions?: {
            sortOption?: string | null
            sortDirection?: Types.SortDirection | null
            groupOption?: string | null
            filterOptions?: Array<{
              type?: string | null
              values?: Array<string | null> | null
            } | null> | null
          } | null
        } | null>
        conditionalFields: Array<{
          fieldId: any
          key: string
          values: Array<{
            id?: any | null
            parentId?: any | null
            type?: Types.PermitFieldType | null
            caption: string
            isMandatory?: boolean | null
            isShown?: boolean | null
            isMultiple?: boolean | null
            canEditIsShown: boolean
            canEditIsMandatory: boolean
            allowPreciseLocation?: boolean | null
            isUserStampEnabled?: boolean | null
            isLBSLogicEnabled?: boolean | null
            allowSelectExisting?: boolean | null
            allowCreateNew?: boolean | null
            selectOptions?: Array<string | null> | null
            isUsedInMaterial?: boolean | null
            mediaView?: Types.MediaViewType | null
            filterOptions?: Array<{
              propertyPath?: string | null
              operator: Types.OperatorType
              values?: Array<string | null> | null
              fieldId?: string | null
              fieldValues?: Array<string | null> | null
            } | null> | null
            instructions?: {
              list?: Array<string | null> | null
              listType?: string | null
            } | null
            checklist?: {
              listType?: string | null
              list?: Array<{
                id?: any | null
                text?: string | null
                questionnaireType?: string | null
              } | null> | null
            } | null
            inlineMediaItems?: Array<{
              fileName: string
              size: string
              url: string
            } | null> | null
            defaultOptions?: {
              sortOption?: string | null
              sortDirection?: Types.SortDirection | null
              groupOption?: string | null
              filterOptions?: Array<{
                type?: string | null
                values?: Array<string | null> | null
              } | null> | null
            } | null
          } | null>
        } | null>
        actions?: Array<
          | {
              locationFieldIds?: Array<any | null> | null
              type?: Types.PermitActionType | null
            }
          | {
              type?: Types.PermitActionType | null
              locationFieldsMap?: Array<{
                fieldId: any
                specifiedPermitTypes?: Array<string | null> | null
                isDisabled?: boolean | null
              } | null> | null
            }
          | null
        > | null
      } | null> | null
      recurringOptions?: {
        isEnabled?: boolean | null
        maxDuration?: number | null
      } | null
      maxDurationOptions?: {
        isEnabled?: boolean | null
        durationType?: Types.WorkflowDurationType | null
        durationUnit?: Types.WorkflowDurationUnit | null
        duration?: number | null
      } | null
      defaultDurationOptions?: {
        isEnabled?: boolean | null
        durationType?: Types.WorkflowDurationType | null
        durationUnit?: Types.WorkflowDurationUnit | null
        duration?: number | null
      } | null
    }>
  } | null
}

export type IListenPermitTypesByProjectIdSubscriptionVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IListenPermitTypesByProjectIdSubscription = {
  permitType?: {
    id?: any | null
    item?: {
      id?: any | null
      orderIndex: number
      projectId: any
      name?: string | null
      basedOn?: any | null
      isEnabled: boolean
      categoryId?: any | null
      type: string
      shouldBlockOnNonWorkTimes?: boolean | null
      isAutoActivationEnabled?: boolean | null
      autoEndStepIds?: Array<any | null> | null
      isWorkflowTitleMandatory?: boolean | null
      isDeleted?: boolean | null
      iconName?: string | null
      createdAt?: any | null
      updatedAt?: any | null
      inspectionOptions?: {
        deadlineTime?: any | null
        inspectionFrequency?: number | null
        inspectionFrequencyType?: Types.CalendricalType | null
        selectedDaysToRepeat?: Array<number | null> | null
      } | null
      bookingDeadlineOptions?: {
        deadlineInterval?: any | null
        blockType?: Types.BlockTypeEnum | null
      } | null
      workflowSteps?: Array<{
        id?: any | null
        type: Types.WorkflowStepType
        workflowRuleIds: Array<any | null>
        notificationFieldIds: Array<any | null>
        notificationUserIds?: Array<any | null> | null
        requireAllSubmissions?: boolean | null
        bicCompletionMode?: Types.BicCompletionMode | null
        fields: Array<{
          id?: any | null
          parentId?: any | null
          type?: Types.PermitFieldType | null
          caption: string
          isMandatory?: boolean | null
          isShown?: boolean | null
          isMultiple?: boolean | null
          canEditIsShown: boolean
          canEditIsMandatory: boolean
          allowPreciseLocation?: boolean | null
          isUserStampEnabled?: boolean | null
          isLBSLogicEnabled?: boolean | null
          allowSelectExisting?: boolean | null
          allowCreateNew?: boolean | null
          selectOptions?: Array<string | null> | null
          isUsedInMaterial?: boolean | null
          mediaView?: Types.MediaViewType | null
          filterOptions?: Array<{
            propertyPath?: string | null
            operator: Types.OperatorType
            values?: Array<string | null> | null
            fieldId?: string | null
            fieldValues?: Array<string | null> | null
          } | null> | null
          instructions?: {
            list?: Array<string | null> | null
            listType?: string | null
          } | null
          checklist?: {
            listType?: string | null
            list?: Array<{
              id?: any | null
              text?: string | null
              questionnaireType?: string | null
            } | null> | null
          } | null
          inlineMediaItems?: Array<{
            fileName: string
            size: string
            url: string
          } | null> | null
          defaultOptions?: {
            sortOption?: string | null
            sortDirection?: Types.SortDirection | null
            groupOption?: string | null
            filterOptions?: Array<{
              type?: string | null
              values?: Array<string | null> | null
            } | null> | null
          } | null
        } | null>
        conditionalFields: Array<{
          fieldId: any
          key: string
          values: Array<{
            id?: any | null
            parentId?: any | null
            type?: Types.PermitFieldType | null
            caption: string
            isMandatory?: boolean | null
            isShown?: boolean | null
            isMultiple?: boolean | null
            canEditIsShown: boolean
            canEditIsMandatory: boolean
            allowPreciseLocation?: boolean | null
            isUserStampEnabled?: boolean | null
            isLBSLogicEnabled?: boolean | null
            allowSelectExisting?: boolean | null
            allowCreateNew?: boolean | null
            selectOptions?: Array<string | null> | null
            isUsedInMaterial?: boolean | null
            mediaView?: Types.MediaViewType | null
            filterOptions?: Array<{
              propertyPath?: string | null
              operator: Types.OperatorType
              values?: Array<string | null> | null
              fieldId?: string | null
              fieldValues?: Array<string | null> | null
            } | null> | null
            instructions?: {
              list?: Array<string | null> | null
              listType?: string | null
            } | null
            checklist?: {
              listType?: string | null
              list?: Array<{
                id?: any | null
                text?: string | null
                questionnaireType?: string | null
              } | null> | null
            } | null
            inlineMediaItems?: Array<{
              fileName: string
              size: string
              url: string
            } | null> | null
            defaultOptions?: {
              sortOption?: string | null
              sortDirection?: Types.SortDirection | null
              groupOption?: string | null
              filterOptions?: Array<{
                type?: string | null
                values?: Array<string | null> | null
              } | null> | null
            } | null
          } | null>
        } | null>
        actions?: Array<
          | {
              locationFieldIds?: Array<any | null> | null
              type?: Types.PermitActionType | null
            }
          | {
              type?: Types.PermitActionType | null
              locationFieldsMap?: Array<{
                fieldId: any
                specifiedPermitTypes?: Array<string | null> | null
                isDisabled?: boolean | null
              } | null> | null
            }
          | null
        > | null
      } | null> | null
      recurringOptions?: {
        isEnabled?: boolean | null
        maxDuration?: number | null
      } | null
      maxDurationOptions?: {
        isEnabled?: boolean | null
        durationType?: Types.WorkflowDurationType | null
        durationUnit?: Types.WorkflowDurationUnit | null
        duration?: number | null
      } | null
      defaultDurationOptions?: {
        isEnabled?: boolean | null
        durationType?: Types.WorkflowDurationType | null
        durationUnit?: Types.WorkflowDurationUnit | null
        duration?: number | null
      } | null
    } | null
  } | null
}

export type ISavePermitTypesMutationVariables = Types.Exact<{
  permitTypes:
    | Array<Types.InputMaybe<Types.IPermitTypeInput>>
    | Types.InputMaybe<Types.IPermitTypeInput>
  projectId: Types.Scalars['ObjectId']['input']
  actions?: Types.InputMaybe<
    | Array<Types.InputMaybe<Types.IPermitTypeActionsDtoInput>>
    | Types.InputMaybe<Types.IPermitTypeActionsDtoInput>
  >
  operationRules?: Types.InputMaybe<
    Array<Types.IOperationRuleInput> | Types.IOperationRuleInput
  >
  deletedOperationRuleIds?: Types.InputMaybe<
    | Array<Types.Scalars['ObjectId']['input']>
    | Types.Scalars['ObjectId']['input']
  >
}>

export type ISavePermitTypesMutation = {
  saveManyPermitTypes?: Array<{
    id?: any | null
    orderIndex: number
    projectId: any
    name?: string | null
    basedOn?: any | null
    isEnabled: boolean
    categoryId?: any | null
    type: string
    shouldBlockOnNonWorkTimes?: boolean | null
    isAutoActivationEnabled?: boolean | null
    autoEndStepIds?: Array<any | null> | null
    isWorkflowTitleMandatory?: boolean | null
    isDeleted?: boolean | null
    iconName?: string | null
    createdAt?: any | null
    updatedAt?: any | null
    inspectionOptions?: {
      deadlineTime?: any | null
      inspectionFrequency?: number | null
      inspectionFrequencyType?: Types.CalendricalType | null
      selectedDaysToRepeat?: Array<number | null> | null
    } | null
    bookingDeadlineOptions?: {
      deadlineInterval?: any | null
      blockType?: Types.BlockTypeEnum | null
    } | null
    workflowSteps?: Array<{
      id?: any | null
      type: Types.WorkflowStepType
      workflowRuleIds: Array<any | null>
      notificationFieldIds: Array<any | null>
      notificationUserIds?: Array<any | null> | null
      requireAllSubmissions?: boolean | null
      bicCompletionMode?: Types.BicCompletionMode | null
      fields: Array<{
        id?: any | null
        parentId?: any | null
        type?: Types.PermitFieldType | null
        caption: string
        isMandatory?: boolean | null
        isShown?: boolean | null
        isMultiple?: boolean | null
        canEditIsShown: boolean
        canEditIsMandatory: boolean
        allowPreciseLocation?: boolean | null
        isUserStampEnabled?: boolean | null
        isLBSLogicEnabled?: boolean | null
        allowSelectExisting?: boolean | null
        allowCreateNew?: boolean | null
        selectOptions?: Array<string | null> | null
        isUsedInMaterial?: boolean | null
        mediaView?: Types.MediaViewType | null
        filterOptions?: Array<{
          propertyPath?: string | null
          operator: Types.OperatorType
          values?: Array<string | null> | null
          fieldId?: string | null
          fieldValues?: Array<string | null> | null
        } | null> | null
        instructions?: {
          list?: Array<string | null> | null
          listType?: string | null
        } | null
        checklist?: {
          listType?: string | null
          list?: Array<{
            id?: any | null
            text?: string | null
            questionnaireType?: string | null
          } | null> | null
        } | null
        inlineMediaItems?: Array<{
          fileName: string
          size: string
          url: string
        } | null> | null
        defaultOptions?: {
          sortOption?: string | null
          sortDirection?: Types.SortDirection | null
          groupOption?: string | null
          filterOptions?: Array<{
            type?: string | null
            values?: Array<string | null> | null
          } | null> | null
        } | null
      } | null>
      conditionalFields: Array<{
        fieldId: any
        key: string
        values: Array<{
          id?: any | null
          parentId?: any | null
          type?: Types.PermitFieldType | null
          caption: string
          isMandatory?: boolean | null
          isShown?: boolean | null
          isMultiple?: boolean | null
          canEditIsShown: boolean
          canEditIsMandatory: boolean
          allowPreciseLocation?: boolean | null
          isUserStampEnabled?: boolean | null
          isLBSLogicEnabled?: boolean | null
          allowSelectExisting?: boolean | null
          allowCreateNew?: boolean | null
          selectOptions?: Array<string | null> | null
          isUsedInMaterial?: boolean | null
          mediaView?: Types.MediaViewType | null
          filterOptions?: Array<{
            propertyPath?: string | null
            operator: Types.OperatorType
            values?: Array<string | null> | null
            fieldId?: string | null
            fieldValues?: Array<string | null> | null
          } | null> | null
          instructions?: {
            list?: Array<string | null> | null
            listType?: string | null
          } | null
          checklist?: {
            listType?: string | null
            list?: Array<{
              id?: any | null
              text?: string | null
              questionnaireType?: string | null
            } | null> | null
          } | null
          inlineMediaItems?: Array<{
            fileName: string
            size: string
            url: string
          } | null> | null
          defaultOptions?: {
            sortOption?: string | null
            sortDirection?: Types.SortDirection | null
            groupOption?: string | null
            filterOptions?: Array<{
              type?: string | null
              values?: Array<string | null> | null
            } | null> | null
          } | null
        } | null>
      } | null>
      actions?: Array<
        | {
            locationFieldIds?: Array<any | null> | null
            type?: Types.PermitActionType | null
          }
        | {
            type?: Types.PermitActionType | null
            locationFieldsMap?: Array<{
              fieldId: any
              specifiedPermitTypes?: Array<string | null> | null
              isDisabled?: boolean | null
            } | null> | null
          }
        | null
      > | null
    } | null> | null
    recurringOptions?: {
      isEnabled?: boolean | null
      maxDuration?: number | null
    } | null
    maxDurationOptions?: {
      isEnabled?: boolean | null
      durationType?: Types.WorkflowDurationType | null
      durationUnit?: Types.WorkflowDurationUnit | null
      duration?: number | null
    } | null
    defaultDurationOptions?: {
      isEnabled?: boolean | null
      durationType?: Types.WorkflowDurationType | null
      durationUnit?: Types.WorkflowDurationUnit | null
      duration?: number | null
    } | null
  } | null> | null
}

export type IDeletePermitTypesMutationVariables = Types.Exact<{
  ids:
    | Array<Types.InputMaybe<Types.Scalars['ObjectId']['input']>>
    | Types.InputMaybe<Types.Scalars['ObjectId']['input']>
}>

export type IDeletePermitTypesMutation = {
  softDeleteManyPermitTypes?: boolean | null
}

export const PermitTypeFragmentFragmentDoc = gql`
  fragment PermitTypeFragment on PermitType {
    id
    orderIndex
    projectId
    name
    basedOn
    isEnabled
    categoryId
    inspectionOptions {
      deadlineTime
      inspectionFrequency
      inspectionFrequencyType
      selectedDaysToRepeat
    }
    bookingDeadlineOptions {
      deadlineInterval
      blockType
    }
    type
    workflowSteps {
      id
      type
      fields {
        ...PermitTypeFieldsFragment
      }
      conditionalFields {
        fieldId
        key
        values {
          ...PermitTypeFieldsFragment
        }
      }
      workflowRuleIds
      notificationFieldIds
      notificationUserIds
      requireAllSubmissions
      bicCompletionMode
      actions {
        type
        ... on StartClosureAction {
          locationFieldsMap {
            fieldId
            specifiedPermitTypes
            isDisabled
          }
        }
        ... on EndClosureAction {
          locationFieldIds
        }
      }
    }
    recurringOptions {
      isEnabled
      maxDuration
    }
    shouldBlockOnNonWorkTimes
    isAutoActivationEnabled
    autoEndStepIds
    isWorkflowTitleMandatory
    isDeleted
    maxDurationOptions {
      isEnabled
      durationType
      durationUnit
      duration
    }
    defaultDurationOptions {
      isEnabled
      durationType
      durationUnit
      duration
    }
    iconName
    createdAt
    updatedAt
  }
  ${PermitTypeFieldsFragmentFragmentDoc}
`
export const PermitTypeListDocument = gql`
  query PermitTypeList($projectId: ObjectId!) {
    permitTypes(limit: 1000000, projectId: $projectId) {
      data {
        ...PermitTypeFragment
      }
    }
  }
  ${PermitTypeFragmentFragmentDoc}
`

/**
 * __usePermitTypeListQuery__
 *
 * To run a query within a React component, call `usePermitTypeListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermitTypeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermitTypeListQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePermitTypeListQuery(
  baseOptions: Apollo.QueryHookOptions<
    IPermitTypeListQuery,
    IPermitTypeListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IPermitTypeListQuery, IPermitTypeListQueryVariables>(
    PermitTypeListDocument,
    options,
  )
}
export function usePermitTypeListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IPermitTypeListQuery,
    IPermitTypeListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IPermitTypeListQuery,
    IPermitTypeListQueryVariables
  >(PermitTypeListDocument, options)
}
export type PermitTypeListQueryHookResult = ReturnType<
  typeof usePermitTypeListQuery
>
export type PermitTypeListLazyQueryHookResult = ReturnType<
  typeof usePermitTypeListLazyQuery
>
export type PermitTypeListQueryResult = Apollo.QueryResult<
  IPermitTypeListQuery,
  IPermitTypeListQueryVariables
>
export const ListenPermitTypesByProjectIdDocument = gql`
  subscription ListenPermitTypesByProjectId($projectId: ObjectId!) {
    permitType(projectId: $projectId) {
      id
      item {
        ...PermitTypeFragment
      }
    }
  }
  ${PermitTypeFragmentFragmentDoc}
`

/**
 * __useListenPermitTypesByProjectIdSubscription__
 *
 * To run a query within a React component, call `useListenPermitTypesByProjectIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenPermitTypesByProjectIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenPermitTypesByProjectIdSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useListenPermitTypesByProjectIdSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    IListenPermitTypesByProjectIdSubscription,
    IListenPermitTypesByProjectIdSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    IListenPermitTypesByProjectIdSubscription,
    IListenPermitTypesByProjectIdSubscriptionVariables
  >(ListenPermitTypesByProjectIdDocument, options)
}
export type ListenPermitTypesByProjectIdSubscriptionHookResult = ReturnType<
  typeof useListenPermitTypesByProjectIdSubscription
>
export type ListenPermitTypesByProjectIdSubscriptionResult =
  Apollo.SubscriptionResult<IListenPermitTypesByProjectIdSubscription>
export const SavePermitTypesDocument = gql`
  mutation SavePermitTypes(
    $permitTypes: [PermitTypeInput]!
    $projectId: ObjectId!
    $actions: [PermitTypeActionsDTOInput]
    $operationRules: [OperationRuleInput!]
    $deletedOperationRuleIds: [ObjectId!]
  ) {
    saveManyPermitTypes(
      permitTypes: $permitTypes
      projectId: $projectId
      actions: $actions
      operationRules: $operationRules
      deletedOperationRuleIds: $deletedOperationRuleIds
    ) {
      ...PermitTypeFragment
    }
  }
  ${PermitTypeFragmentFragmentDoc}
`
export type ISavePermitTypesMutationFn = Apollo.MutationFunction<
  ISavePermitTypesMutation,
  ISavePermitTypesMutationVariables
>

/**
 * __useSavePermitTypesMutation__
 *
 * To run a mutation, you first call `useSavePermitTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePermitTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePermitTypesMutation, { data, loading, error }] = useSavePermitTypesMutation({
 *   variables: {
 *      permitTypes: // value for 'permitTypes'
 *      projectId: // value for 'projectId'
 *      actions: // value for 'actions'
 *      operationRules: // value for 'operationRules'
 *      deletedOperationRuleIds: // value for 'deletedOperationRuleIds'
 *   },
 * });
 */
export function useSavePermitTypesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISavePermitTypesMutation,
    ISavePermitTypesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISavePermitTypesMutation,
    ISavePermitTypesMutationVariables
  >(SavePermitTypesDocument, options)
}
export type SavePermitTypesMutationHookResult = ReturnType<
  typeof useSavePermitTypesMutation
>
export type SavePermitTypesMutationResult =
  Apollo.MutationResult<ISavePermitTypesMutation>
export type SavePermitTypesMutationOptions = Apollo.BaseMutationOptions<
  ISavePermitTypesMutation,
  ISavePermitTypesMutationVariables
>
export const DeletePermitTypesDocument = gql`
  mutation DeletePermitTypes($ids: [ObjectId]!) {
    softDeleteManyPermitTypes(ids: $ids)
  }
`
export type IDeletePermitTypesMutationFn = Apollo.MutationFunction<
  IDeletePermitTypesMutation,
  IDeletePermitTypesMutationVariables
>

/**
 * __useDeletePermitTypesMutation__
 *
 * To run a mutation, you first call `useDeletePermitTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePermitTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePermitTypesMutation, { data, loading, error }] = useDeletePermitTypesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeletePermitTypesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeletePermitTypesMutation,
    IDeletePermitTypesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeletePermitTypesMutation,
    IDeletePermitTypesMutationVariables
  >(DeletePermitTypesDocument, options)
}
export type DeletePermitTypesMutationHookResult = ReturnType<
  typeof useDeletePermitTypesMutation
>
export type DeletePermitTypesMutationResult =
  Apollo.MutationResult<IDeletePermitTypesMutation>
export type DeletePermitTypesMutationOptions = Apollo.BaseMutationOptions<
  IDeletePermitTypesMutation,
  IDeletePermitTypesMutationVariables
>
